import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { Invoice } from '../types'

export const useInvoice = (id: number): UseQueryResult<Invoice, Error> => {
  return useQuery<Invoice, Error>({
    queryKey: ['invoice', id],
    queryFn: () =>
      fetchApiWithToken<Invoice>({
        method: 'get',
        url: `/v1/invoices/${id}`
      }),
    enabled: !!id
  })
}
